<template>
  <b-modal
    ref="modal"
    id="college-event-details-modal"
    class="large-modal"
    size="lg"
  >
    <template #modal-header>
      <div class="upper" v-if="workshop">
        <label>Workshop Details</label>
        <div class="new-title">
          {{workshop.topic}}
        </div>
      </div>
      <button class="close" @click="hide()" >
        ×
      </button>
    </template>
    <div v-if="workshop">
      <p class="date" v-if="workshop.endsOnDifferentDay">
        {{workshop.start_time | format('MMMM Do hh:mm A')}} - {{workshop.end_time | format('MMMM Do h:mm A') }}
      </p>
      <p class="date" v-else>
        {{workshop.start_time | format('MMMM Do hh:mm A')}} - {{workshop.end_time | format('h:mm A')}}
      </p>

      <p>
        Host: {{workshop.host.first_name}} {{workshop.host.last_name}} 
      </p>

      <ul class="pills">
        <li v-if="workshop.num_spots_left === 1">
          {{workshop.num_spots_left}} Spot Left!
        </li>
        <li v-else>
          {{workshop.num_spots_left}} Spots Left!
        </li>
      </ul>

      <div v-if="workshop.description">
        <hr>
        <b class="d-block mt-2 mb-2">Description</b>
        <p class="description">
          {{workshop.description}}
        </p>
      </div>

      <div v-if="workshop.struggle_areas.length">
        <hr >
        <b class="d-block mt-2 mb-2">Topics:</b>
        <ul class="table bm-table" >
          <li v-for="struggle in workshop.struggle_areas" :key="struggle.id">
            {{struggle.name}}
          </li>
        </ul>
      </div>

      <hr>
    </div>

    <template slot="modal-footer" >
      <button class="btn" type="button" 
        @click="hide()" >
        Dismiss
      </button>
      <button class="btn btn--secondary" type="button"
        @click="$emit('cancel', workshop)" >
        Cancel Workshop
      </button>
      <button class="btn btn--primary" type="button"
        @click="$emit('attendees', workshop)" >
        View Attendees
      </button>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'WorkshopAdminViewModal',
  data() {
    return {
      workshop: null
    }
  },
  methods: {
    show(workshop) {
      this.workshop = workshop;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
#college-event-details-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 30px;
    font-weight: 700;
    font-family: "Playfair Display", serif;
    line-height: 1;
    text-transform: capitalize;
  }

  .description {
    opacity: 0.76;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .text-btn {
    border: none;
    background: none;
    color: $red;
    padding: 0;
    outline: none;
    height: auto;
    font-weight: normal;
    margin-top: 25px;
    text-align: right;
    text-transform: none;
    opacity: 0.75;

    &:hover,
    &:focus {
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
